/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { makeStyles } from 'tss-react/mui'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { EyeIcon, EyeClosedIcon } from 'src/assets/svgs'

interface Props {
  label: string
  placeHolder?: string
  id?: string
  name?: string
  value?: any
  type?: string
  onChangeHandler?: (
    e: React.ChangeEvent<any>
  ) =>
    | void
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | React.SyntheticEvent
  error?: boolean
  helperText?: string | false | undefined
}

const PasswordInputField: React.FC<Props> = ({
  label,
  placeHolder,
  id,
  name,
  value,
  onChangeHandler,
  error,
  helperText,
}: Props) => {
  const [showPassword, setShowPassword] = React.useState(false)
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <TextField
        fullWidth
        aria-label={name || ''}
        id={id || ''}
        name={name || ''}
        type={showPassword ? 'text' : 'password'}
        label={label}
        variant="filled"
        placeholder={placeHolder || ''}
        value={value}
        onChange={onChangeHandler}
        error={error || false}
        helperText={helperText || ''}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeIcon /> : <EyeClosedIcon />}
              </IconButton>
            </InputAdornment>
          ),
          autoComplete: 'no',
        }}
        className={classes.formTextfield}
      />
    </div>
  )
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    background: 'white',
    height: '66px',
    border: '1px solid #C5CED6',
    borderRadius: '112px',
    padding: '0 0 4px 0',
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('md')]: {
      borderRadius: '70px',
    },
    ':focus': {
      borderBottom: 'none !important',
      background: 'white',
      height: '66px',
      border: '1px solid #C5CED6',
      borderRadius: '112px',
    },
    'input:-webkit-autofill': {
      height: '66px',
      border: '1px solid #C5CED6',
      borderRadius: '112px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },

    '& label': {
      top: '5px !important',
      left: '6px !important',
      '&.Mui-focused': {
        top: '0px !important',
      },
    },

    '& .MuiFilledInput-root': {
      background: 'none !important',
      ':focus': {
        border: 'none !important',
      },
      ':after': {
        border: 'none !important',
      },
      ':before': {
        border: 'none !important',
      },

      'input:-webkit-autofill': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
      'input:-webkit-autofill:hover': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
      'input:-webkit-autofill:focus': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
    },
  },

  formTextfield: {
    width: 'inherit !important',
    height: '100%',
    borderRadius: '112px',
    [theme.breakpoints.down('md')]: {
      borderRadius: '70px',
    },

    '> input:-webkit-autofill': {
      height: '66px',
      border: '1px solid #C5CED6',
      borderRadius: '112px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },

    '& .MuiInputBase-input': {
      width: '100%',
      height: '63px',
      padding: theme.spacing(1, 4.5),
      fontSize: 14,
      border: 'none',
      borderRadius: '112px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },
  },
}))

export default PasswordInputField
